export const productType = {
  PACKAGES: 'package',
  ADDONS: 'addon',
  PLANS: 'plan',
  CHARGES: 'charge',
};

export type ProductTypes = typeof productType[keyof typeof productType];
